var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = x({ ["notStrictEqual"]: () => __WEBPACK_EXTERNAL_MODULE_assert__.notStrictEqual, ["strictEqual"]: () => __WEBPACK_EXTERNAL_MODULE_assert__.strictEqual });